<template>
  <div v-html="editorContent"></div>
</template>

<script>
import {useCommonStore} from '~/store/common/index.js'

export default {
  name: 'Tab1',
  setup() {
    const commonStore = useCommonStore()
    return {commonStore}
  },
  data() {
    return {
      editorContent: ''
    }
  },
  async mounted() {
    await this.getEditorBoard()
  },
  methods: {
    async getEditorBoard() {
      try {
        this.isSpinner = true
        const payload = {
          parentType: 'magazine',
          type: '01'
        }
        const {data} = await this.commonStore.getEditorBoard(payload)
        this.editorContent = data.board.content
      } catch (error) {
        console.log(error)
      } finally {
        this.isSpinner = false
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
